module.exports = __webpack_public_path__ + "static/media/Lesson-5-14-Discovering-true-Acceptance.2641cec8.pdf";